/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Invite_Codes_CopiedInputs */

const en_admin_invite_codes_copied = /** @type {(inputs: Admin_Invite_Codes_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copied to clipboard`)
};

/**
* | output |
* | --- |
* | "Copied to clipboard" |
*
* @param {Admin_Invite_Codes_CopiedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_invite_codes_copied = /** @type {((inputs?: Admin_Invite_Codes_CopiedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Invite_Codes_CopiedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_invite_codes_copied(inputs)
});
export { admin_invite_codes_copied as "admin.invite_codes.copied" }